import { memo, splitProps } from '../helpers.mjs';
import { createRecipe, mergeRecipes } from './create-recipe.mjs';

const loadingLoaderFn = /* @__PURE__ */ createRecipe('loading-loader', {}, [])

const loadingLoaderVariantMap = {}

const loadingLoaderVariantKeys = Object.keys(loadingLoaderVariantMap)

export const loadingLoader = /* @__PURE__ */ Object.assign(memo(loadingLoaderFn.recipeFn), {
  __recipe__: true,
  __name__: 'loadingLoader',
  __getCompoundVariantCss__: loadingLoaderFn.__getCompoundVariantCss__,
  raw: (props) => props,
  variantKeys: loadingLoaderVariantKeys,
  variantMap: loadingLoaderVariantMap,
  merge(recipe) {
    return mergeRecipes(this, recipe)
  },
  splitVariantProps(props) {
    return splitProps(props, loadingLoaderVariantKeys)
  },
  getVariantProps: loadingLoaderFn.getVariantProps,
})